import { isTelegramHostname, TELEGRAM_HOSTS } from '../telegram/telegram-identity.js';

// One catalogue for URL recognition and UI labels/icons.
export const RESOURCE_PLATFORMS = {
  web: { label: 'Обычные сайты', icon: 'solar:global-bold-duotone', hosts: [] },
  youtube: {
    label: 'YouTube',
    icon: 'simple-icons:youtube',
    hosts: ['youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtu.be'],
  },
  telegram: { label: 'Telegram', icon: 'simple-icons:telegram', hosts: TELEGRAM_HOSTS },
  instagram: { label: 'Instagram', icon: 'simple-icons:instagram', hosts: ['instagram.com'] },
  facebook: {
    label: 'Facebook',
    icon: 'simple-icons:facebook',
    hosts: ['facebook.com', 'm.facebook.com', 'fb.watch'],
  },
  threads: {
    label: 'Threads',
    icon: 'simple-icons:threads',
    hosts: ['threads.net', 'threads.com'],
  },
  tiktok: { label: 'TikTok', icon: 'simple-icons:tiktok', hosts: ['tiktok.com', 'vm.tiktok.com'] },
  vk: { label: 'VK', icon: 'simple-icons:vk', hosts: ['vk.com', 'vk.ru'] },
  x: { label: 'X', icon: 'simple-icons:x', hosts: ['x.com', 'twitter.com'] },
  whatsapp: { label: 'WhatsApp', icon: 'simple-icons:whatsapp', hosts: ['whatsapp.com', 'wa.me'] },
  chatgpt: {
    label: 'ChatGPT',
    icon: 'simple-icons:openai',
    hosts: ['chatgpt.com', 'chat.openai.com'],
  },
  claude: { label: 'Claude', icon: 'simple-icons:claude', hosts: ['claude.ai'] },
  deepseek: {
    label: 'DeepSeek',
    icon: 'solar:chat-round-dots-bold-duotone',
    hosts: ['chat.deepseek.com'],
  },
  gemini: { label: 'Gemini', icon: 'simple-icons:googlegemini', hosts: ['gemini.google.com'] },
} as const;
export type ResourcePlatform = keyof typeof RESOURCE_PLATFORMS;
export const PLATFORM_IDS = Object.keys(RESOURCE_PLATFORMS) as ResourcePlatform[];
export const AI_PLATFORMS = ['chatgpt', 'claude', 'deepseek', 'gemini'] as const;

export function resourcePlatform(hostname: string): ResourcePlatform {
  const host = hostname
    .toLowerCase()
    .replace(/^www\./, '')
    .replace(/\.$/, '');
  if (isTelegramHostname(host)) return 'telegram';
  return (
    PLATFORM_IDS.find((id) => (RESOURCE_PLATFORMS[id].hosts as readonly string[]).includes(host)) ??
    'web'
  );
}
